import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    schoolId: 2,
    subSchoolId: 11
  },
  mutations: {

  },
  getters: {
    schoolId: state => state.schoolId,
    subSchoolId: state => state.subSchoolId,
  }
})

export default store
